import { useCallback, useEffect, useMemo } from 'react';

import { detectMobileOS, storeUrlFor } from '@features/downloadApp';

export default function useDownloadAppPage() {
    const mobileOS = useMemo(() => detectMobileOS(), []);
    const storeUrl = storeUrlFor(mobileOS);

    // `replace` keeps this landing out of history, so "back" from the store
    // returns to wherever the visitor came from instead of bouncing again.
    useEffect(() => {
        if (storeUrl) window.location.replace(storeUrl);
    }, [storeUrl]);

    // Manual fallback for a browser that blocks the automatic redirect.
    const openStore = useCallback(() => {
        if (storeUrl) window.location.href = storeUrl;
    }, [storeUrl]);

    return {
        redirecting: !!storeUrl,
        openStore,
    };
}
